import { lightenColor } from "utils/colors.utils";
import { Button, ButtonPropTypes } from "./Button";
import { useTheme } from "context/ThemeContext";

const SecondaryButton = ({ style = {}, ...restProps }) => {
  const { theme } = useTheme();
  const bgColor = lightenColor(theme.primaryColor, 0.85);
  const secondaryStyle = {
    ...style,
    // backgroundColor: `rgba(${hexToRgb(theme.primaryColor)}, 0.1)`,
    backgroundColor: bgColor,
    color: theme.primaryColor,
  };
  return <Button {...restProps} style={secondaryStyle} />;
};
SecondaryButton.propTypes = ButtonPropTypes;

export default SecondaryButton;
